export enum PageFormat {
    A4,
    A3,
    Letter
}